var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',{staticClass:"uncommon-container",class:_vm.$mq},[_c('div',{staticClass:"contents-container short"},[_c('div',{staticClass:"movie-container"},[_c('youtube-container-shorts',{attrs:{"file-url":'DDVvCYHXMF8',"is-close-btn-white":true}})],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }